
import { useState } from 'react';

interface Product {
  id: number;
  name: string;
  size: string;
  price: string;
  type: 'plegable' | 'autoarmable';
  features: string[];
  image: string;
}

export default function Products() {
  const [selectedTab, setSelectedTab] = useState<'venta' | 'arriendo'>('venta');

  const products: Product[] = [
    {
      id: 1,
      name: 'Módulo Plegable 6x3',
      size: '6x3 metros',
      price: '$3.100.000',
      type: 'plegable',
      features: ['Fácil instalación', 'Estructura resistente', 'Aislación térmica', 'Ventanas incluidas'],
      image: 'https://public.readdy.ai/ai/img_res/7efe10251210215e82e09b9d4ca0e1a7.jpg'
    },
    {
      id: 2,
      name: 'Módulo Plegable 6x6',
      size: '6x6 metros',
      price: '$5.200.000',
      type: 'plegable',
      features: ['Amplio espacio', 'Doble entrada', 'Sistema eléctrico', 'Piso reforzado'],
      image: 'https://readdy.ai/api/search-image?query=Large%20white%20and%20blue%20prefabricated%20modular%20building%206x6%20meters%20with%20modern%20design%2C%20spacious%20appearance%2C%20multiple%20windows%2C%20metal%20frame%20structure%2C%20professional%20product%20photography%20on%20white%20background%2C%20front%20angle%20view%20showing%20full%20module%20dimensions%2C%20high%20quality%20construction%20materials&width=400&height=300&seq=prod2&orientation=landscape'
    },
    {
      id: 3,
      name: 'Módulo Auto Armable 4x4',
      size: '4x4 metros',
      price: '$2.000.000',
      type: 'autoarmable',
      features: ['Montaje rápido', 'Sin herramientas especiales', 'Compacto', 'Versátil'],
      image: 'https://readdy.ai/api/search-image?query=Compact%20white%20and%20blue%20self-assembling%20modular%20building%204x4%20meters%20with%20simple%20modern%20design%2C%20easy%20assembly%20appearance%2C%20standard%20windows%2C%20lightweight%20structure%2C%20professional%20product%20photography%20on%20white%20background%2C%20three-quarter%20view%20showing%20module%20proportions&width=400&height=300&seq=prod3&orientation=landscape'
    },
    {
      id: 4,
      name: 'Módulo Auto Armable 3x3',
      size: '3x3 metros',
      price: '$1.500.000',
      type: 'autoarmable',
      features: ['Económico', 'Ideal para oficinas', 'Rápida instalación', 'Portátil'],
      image: 'https://readdy.ai/api/search-image?query=Small%20white%20and%20blue%20self-assembling%20modular%20building%203x3%20meters%20with%20compact%20modern%20design%2C%20economical%20appearance%2C%20single%20window%2C%20lightweight%20portable%20structure%2C%20professional%20product%20photography%20on%20white%20background%2C%20front%20view%20showing%20small%20module%20dimensions&width=400&height=300&seq=prod4&orientation=landscape'
    },
    {
      id: 5,
      name: 'Módulo Auto Armable 6x3',
      size: '6x3 metros',
      price: '$2.500.000',
      type: 'autoarmable',
      features: ['Rectangular', 'Múltiples usos', 'Fácil transporte', 'Resistente'],
      image: 'https://readdy.ai/api/search-image?query=Rectangular%20white%20and%20blue%20self-assembling%20modular%20building%206x3%20meters%20with%20modern%20design%2C%20versatile%20appearance%2C%20multiple%20windows%2C%20lightweight%20but%20strong%20structure%2C%20professional%20product%20photography%20on%20white%20background%2C%20side%20angle%20view%20showing%20rectangular%20proportions&width=400&height=300&seq=prod5&orientation=landscape'
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="productos" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Nuestros Productos
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos una amplia gama de módulos plegables y auto armables para satisfacer todas tus necesidades de construcción modular.
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <div className="bg-white rounded-full p-1 shadow-sm">
            <button
              onClick={() => setSelectedTab('venta')}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                selectedTab === 'venta'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Venta
            </button>
            <button
              onClick={() => setSelectedTab('arriendo')}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                selectedTab === 'arriendo'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Arriendo
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48 bg-gray-100">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    product.type === 'plegable' 
                      ? 'bg-blue-100 text-blue-800' 
                      : 'bg-green-100 text-green-800'
                  }`}>
                    {product.type === 'plegable' ? 'Plegable' : 'Auto Armable'}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h4 className="text-xl font-bold text-gray-900 mb-2">{product.name}</h4>
                <p className="text-gray-600 mb-4">{product.size}</p>
                
                <div className="mb-4">
                  <div className="text-2xl font-bold text-blue-600 mb-2">
                    {selectedTab === 'venta' ? product.price : `${Math.round(parseInt(product.price.replace(/[$.]/g, '')) * 0.15).toLocaleString('es-CL')} /mes`}
                  </div>
                  {selectedTab === 'arriendo' && (
                    <p className="text-sm text-gray-500">Arriendo mensual</p>
                  )}
                </div>

                <ul className="space-y-2 mb-6">
                  {product.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button 
                  onClick={scrollToContact}
                  className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Solicitar Cotización
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-50 rounded-2xl p-8 text-center">
          <h4 className="text-2xl font-bold text-gray-900 mb-4">¿Necesitas algo personalizado?</h4>
          <p className="text-gray-600 mb-6">
            También fabricamos módulos a medida según tus especificaciones. Contáctanos para una cotización personalizada.
          </p>
          <button 
            onClick={scrollToContact}
            className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Cotizar Proyecto Personalizado
          </button>
        </div>
      </div>
    </section>
  );
}
